import * as types from '../actionTypes/clientsActionsType';
import * as clientTypes from '../actionTypes/clientActionTypes';
const selectedClient = localStorage.getItem('selectedClient');
const initialState = {
    selectedClient: selectedClient ? JSON.parse(selectedClient) : null,
    clients: [],
    loading: false,
};
const clientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CLIENTS_FETCH:
            return Object.assign(Object.assign({}, state), { clients: action.payload });
        case types.CLIENT_UPDATE: {
            const updatedClients = state.clients.map((c) => {
                if (c.code !== action.payload.code) {
                    return c;
                }
                return Object.assign(Object.assign({}, c), action.payload);
            });
            return Object.assign(Object.assign({}, state), { clients: updatedClients });
        }
        case clientTypes.CLIENTS_FETCH_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true });
        case clientTypes.CLIENTS_FETCH_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, clients: action.clients });
        case types.CLIENT_SELECT:
            localStorage.setItem('selectedClient', JSON.stringify(action.payload));
            return Object.assign(Object.assign({}, state), { selectedClient: action.payload });
        default:
            return state;
    }
};
export default clientsReducer;
